/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/9/29 16:36
 * @FileName: business-introduction.js
 * @LastEditor: 2022/9/29 16:36
 * @Name: business-introduction
 */

const businessIntroduction = {
  routes: [
    {
      path: '/businessIntroduction',
      name: 'businessIntroduction',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/business-introduction/business-introduction.vue')
    }
  ]
};
export default businessIntroduction;



// WEBPACK FOOTER //
// ./src/project/router/businessIntroduction.js